import {Button} from "antd";
import React, {useCallback, useEffect} from "react";
import {Store} from "pullstate";
import {httpsFunctions} from "./api/Api";
import {ResetPasswordState} from "./hooks/useResetPageAction";

const ResetPasswordStore = new Store({
    email: null,
    memberId: null,
    password: "",
    confirmPassword: "",
    showPassword: false,
    error: null,
    clientError: null,
    loading: true,
    submitLoading: false,
    passwordChanged: false,
});

const onResult = response => {
    const {member, error} = response.data;
    ResetPasswordStore.update(s => {
        if (member) {
            s.email = member.Email;
            s.memberId = member.id;
        } else {
            s.error = error;
        }
        s.loading = false;
    });
}

const onError = error => {
    ResetPasswordStore.update(s => {
        s.error = error.error;
        s.loading = false;
    });
}

const useRecognizeUserLoadEffect = () => {
    const token = ResetPasswordState.useToken();
    useEffect(() => {
        if(token){
            httpsFunctions.get(`/getResetMember?token=${token}`)
                .then(onResult)
                .catch(onError)
        }

    }, [token]);
}

const setPassword = (password) => {
    ResetPasswordStore.update(s => {
        s.password = password;
    });
}

const setConfirmPassword = (confirmPassword) => {
    ResetPasswordStore.update(s => {
        s.confirmPassword = confirmPassword;
    });
}

const toggleShowPassword = () => {
    ResetPasswordStore.update(s => {
        s.showPassword = !s.showPassword;
    });
}


const infoStyle = {
    display: "flex",
    color: "white",
    flexDirection: "column",
    paddingBottom: '2rem',
    fontSize: "0.8rem",
}

const pStyle = {
    padding: "0 3px",
    margin: 0,
    fontSize: "1rem",
}

export const Info = () => {
    const {email, memberId} = ResetPasswordStore.useState();
    return (
        <div style={infoStyle}>
            <p style={pStyle}>Olet palauttamassa salasanan:</p>
            <p style={pStyle}><b>{email} (SGS-jäsennumero {memberId})</b></p>
            <br/>
            <div>
                - Salasanan tulee olla vähintään 6 merkkiä pitkä.
            </div>
        </div>
    )
}


const customStyles = {
    // top: "50%",
    // left: "50%",
    right: "auto",
    bottom: "auto",
    inset: "auto",
    // marginRight: "-50%",
    // transform: "translate(-50%, -50%)",
    backgroundImage: "linear-gradient(to bottom, #003B7E , #0D6EFF)",
    borderRadius: 0,
    // width: "100vw",
    height: "100vh",
    padding: "7% 10%",
};

const ShowPasswordCheckbox = () => {
    const {showPassword} = ResetPasswordStore.useState();

    return (
        <div className='form-check'>
            <input
                className='form-check-input'
                type='checkbox'
                checked={showPassword}
                id='flexCheckDefault'
                onChange={toggleShowPassword}
            />
            <label className='form-check-label' htmlFor='flexCheckDefault' style={{color: "white"}}>
                {showPassword ? "Piilota salasana" : "Näytä salasana"}
            </label>
        </div>
    )
}

const Error = () => {
    const {clientError} = ResetPasswordStore.useState();
    return clientError ? (
        <div style={{color: "#FCB3BB", fontSize: "1 rem", paddingBottom: 10}}>
            {clientError}
        </div>
    ) : null
}


const SubmitButton = () => {
    const token = ResetPasswordState.useToken();
    const submitLoading = ResetPasswordStore.useState(s => s.submitLoading);
    const {password, confirmPassword, memberId} = ResetPasswordStore.useState();
    const onClick = useCallback(() => {
            if (password.length < 6) {
                ResetPasswordStore.update(s => {
                    s.clientError = "Salasanan tulee olla vähintään 6 merkkiä pitkä.";
                });
                return;
            }
            if (password !== confirmPassword) {
                ResetPasswordStore.update(s => {
                    s.clientError = "Salasanat eivät täsmää.";
                });
                return;
            }
            ResetPasswordStore.update(s => {
                s.clientError = null;
            });
            ResetPasswordStore.update(s => {
                s.submitLoading = true;
            })

            httpsFunctions.post('/resetMemberPassword', {newPassword: password, token})
                .then(response => {
                    const {error} = response.data;
                    if (error) {
                        ResetPasswordStore.update(s => {
                            s.clientError = error;
                        });
                    } else {
                        ResetPasswordStore.update(s => {
                            s.error = null;
                            s.passwordChanged = true;
                        });
                    }
                })
                .catch(error => {
                    ResetPasswordStore.update(s => {
                        s.clientError = error.error;
                    });
                })
                .finally(() => {
                    ResetPasswordStore.update(s => {
                        s.submitLoading = false;
                    })
                });
        }, [password, confirmPassword, memberId, token]
    )
    return  (
        <Button
            disabled={submitLoading}
            loading={submitLoading}
            onClick={onClick}
            // className='btn btn-primary'
            style={{
                marginTop: 20,
                width: "fit-content",
                borderColor: "white",
                background: "#476da5",
                color: "white",
            }}
            // disabled={false}
        >
            Tallenna salasana
        </Button>
    )
}

export const Success = () => {

    // redirect user for main page in 10 seconds

    const [seconds, setSeconds] = React.useState(10);
    useEffect(() => {
        const interval = setInterval(() => {
            setSeconds(seconds => seconds - 1);
        }, 1000);
        return () => clearInterval(interval);
    },[])

    useEffect(() => {
        if (seconds === 0) {
            window.location.href = "/";
        }
    }, [seconds])

    return (
        <div style={customStyles}>
            <div style={{color: "white", fontSize: "1.5rem", textAlign: "center", paddingTop: "2rem"}}>
                Salasana on tallennettu.
            </div>
            {/*you will be redirect to main page in {seconds}*/}
            <a style={{color: "white"}} href="/"> sinut ohjataan pääsivulle {seconds} </a>
        </div>
    )
}

export const ResetPasswordInput = ({name, label, value, setValue, showPassword}) => {
    return (
        (
            <div className='mb-3 row'>
                <label htmlFor={name} className=' col-form-label'
                       style={{fontSize: 16, color: "white"}}>
                    {label}
                </label>
                <div className=''>
                    <input
                        type={showPassword ? 'text' : 'password'}
                        name={name}
                        className='form-control'
                        id={name}
                        value={value}
                        onChange={e => setValue(e.currentTarget.value != "" ? e.currentTarget.value.trim() : "")}
                        maxLength={24}
                    />
                </div>
            </div>
        )
    )
}

export const Loading = () => {
    return (
        <div style={customStyles}>
            <div className={'loading-indicator'} style={{color: "white", fontSize: "1.5rem", textAlign: "center", paddingTop: "2rem"}}>
                Loading...
            </div>
        </div>

    )
}

export const ErrorPage = () => {
    return (
        <div style={customStyles}>
            <div style={{color: "white", fontSize: "1.5rem", textAlign: "center", paddingTop: "2rem"}}>
                Error, the link is invalid or expired.
            </div>
        </div>
    )
}

export const ResetPassword = () => {
    const {password, confirmPassword, showPassword, loading, error, passwordChanged} = ResetPasswordStore.useState();
    useRecognizeUserLoadEffect();
    return loading ? <Loading/> :
        error ? <ErrorPage/> :
            passwordChanged ? <Success/> :
                (
                    <div style={customStyles}>
                        <Info/>
                        <form>
                            <ResetPasswordInput
                                name={'password'}
                                label={'Salasana'}
                                value={password}
                                showPassword={showPassword}
                                setValue={setPassword}
                            />
                            <ResetPasswordInput
                                name={'confirmPassword'}
                                label={'Kirjoita salasana uudelleen'}
                                value={confirmPassword}
                                showPassword={showPassword}
                                setValue={setConfirmPassword}
                            />
                            <Error/>
                            <ShowPasswordCheckbox/>
                            <div className='row' style={{alignItems: "center", justifyContent: "center"}}>
                                <SubmitButton/>
                            </div>
                        </form>
                    </div>
                )
}
